module.exports = __webpack_public_path__ + "static/media/LocalBanner.f9fc4c39.svg";